import Vue from 'vue'

const config = {
  method: 'GET',
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

const urlBaseIBGE = 'https://servicodados.ibge.gov.br/api/v1/localidades'
let url = ''
Vue.prototype.$ibge = {
  states() {
    // return fetch(route('api.addresses.states')).then((response) => response.json())
    // REFECTORY TO WORK, CLOUD NOT BE THE BEST WAY BUT WORKS
    return fetch( `${urlBaseIBGE}/estados`).then((response) => response.json())
  },

  cities(codeState = null) {
    if (codeState) {
      // REFECTORY TO WORK, CLOUD NOT BE THE BEST WAY BUT WORKS
      // url = route('api.addresses.cities', codeState);
        url = `${urlBaseIBGE}/estados/${codeState}/municipios`
    } else {
      // REFECTORY TO WORK, CLOUD NOT BE THE BEST WAY BUT WORKS
      // url = route('api.addresses.cities');
        url = `${urlBaseIBGE}/municipios`
    }

    return fetch(url).then((response) => response.json())
  },
  //UNECESARY
  neighborhoods(codeCity = null) {
    if (codeCity) {
      url = route('api.addresses.neighborhoods', codeCity)
    } else {
      url = route('api.addresses.neighborhoods')
    }

    return fetch(url, config).then((response) => response.json())
  }
}

/**
 *
 * @type {{searchCep: (function(*): Promise<any>)}}
 */
Vue.prototype.$viaCep = {
  /**
   *
   * @param cep
   * @return {Promise<any | any> | Object}
   */
  searchCep(cep) {
    return fetch(route('api.addresses.searchCep', cep))
      .then((response) => response.json())
  }
}
